import { Separator } from "@radix-ui/react-separator"
import {
  Book,
  Calendar,
  Clock,
  FileText,
  HelpCircle,
  Tag,
  Trophy,
  Users,
  Video,
} from "lucide-react"
import Link from "@/components/Link"
import type { CourseDetail } from "@/lib/types/course/detail"

interface CourseFeaturesProps {
  course: CourseDetail
}

const CourseFeatures: React.FC<CourseFeaturesProps> = ({ course }) => {
  return (
    <div className="px-6 pb-3">
      <div className="relative mt-4">
        <Separator className="absolute inset-0" />
        <p className="relative z-10 mb-2 bg-white pr-2 font-bold text-base text-gray-700">
          Khoá học bao gồm
        </p>
      </div>

      <ul className="text-gray-600 text-sm">
        <li className="mb-1">
          <Book className="inline-block h-4 w-4" /> Hình thức:{" "}
          <b>{course.learning_mode || "Google Meet"}</b>
        </li>
        <li className="mb-1">
          <Calendar className="inline-block h-4 w-4" /> Lịch học:{" "}
          <b>{course.schedule || "Linh hoạt"}</b>
        </li>
        <li className="mb-1">
          <Users className="inline-block h-4 w-4" /> Học viên:{" "}
          <b>{course.count_user  + course.number_of_students || 0}</b>
        </li>
        <li className="mb-1">
          <Video className="inline-block h-4 w-4" /> Số bài học:{" "}
          <b>{course.total_videos || 0}</b> videos
        </li>
        <li className="mb-1">
          <Clock className="inline-block h-4 w-4" /> Thời lượng:{" "}
          <b>{course.hour || 0}</b> giờ
        </li>
        <li className="mb-1">
          <FileText className="inline-block h-4 w-4" /> Tài nguyên:{" "}
          <b>{"App mẫu + Tài liệu"}</b>
        </li>
        <li className="mb-1">
          <HelpCircle className="inline-block h-4 w-4" /> Hỗ trợ:{" "}
          <b>{"Giải đáp 24/7"}</b>
        </li>
        <li className="mb-1">
          <Users className="inline-block h-4 w-4" /> Cộng đồng:{" "}
          <b>{"Nhóm Zalo"}</b>
        </li>
        <li className="mb-1">
          <Trophy className="inline-block h-4 w-4" /> Cấp chứng chỉ hoàn thành
        </li>
      </ul>
    </div>
  )
}

export default CourseFeatures 